<template>
  <SideDrawer :showDrawerBackdrop="showDrawerBackdrop" :showDrawerPanel="showDrawerPanel" activeView="widget" @close-drawer="$emit('close')" drawerTitle="Gestisci i Widget della Dashboard">
    <template #body>
      <div class="container-fluid px-0">
        <div class="row">
          <div class="col-6">
            <div class="mb-3 text-muted font-weight-bold">Nome del widget</div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col text-center text-muted font-weight-bold">Dashboard pubblica</div>
              <div class="col text-center text-muted font-weight-bold">Dashboard privata</div>
            </div>
          </div>
        </div>

        <FormContainer>
          <div class="container-fluid px-0">
            <div class="row py-2" v-for="(widget, i) in widgets" :key="i" :class="{'border-bottom' : i !== widgets.length}">
              <div class="col-6">
                <p class="font-weight-light mb-0">
                  {{ widget.name }}
                </p>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col text-center">
                    <BFormCheckbox v-model="publicEnabledWidgets" name="publicWidgets" :value="widget.id" switch size="lg"></BFormCheckbox>
                  </div>
                  <div class="col text-center">
                    <BFormCheckbox v-model="privateEnabledWidgets" name="privateWidgets" :value="widget.id" switch size="lg"></BFormCheckbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FormContainer>
      </div>
    </template>

    <template #footer>
      <button class="btn btn-primary" @click="saveDashboardConfig">Salva</button>
    </template>
  </SideDrawer>
</template>

<script>

import { BFormCheckbox } from 'bootstrap-vue';

export default {
  name: 'dashboard-config-side-drawer',
  components: {
    SideDrawer: () => import('../SideDrawer'),
    FormContainer: () => import('../../../libs/Form/components/FormContainer'),
    BFormCheckbox,
  },
  props: {
    showDrawer: {
      type: Boolean,
      default: true,
    },
    company: {
      type: Object,
    },
  },
  data () {
    return {
      showDrawerBackdrop: true,
      showDrawerPanel: true,
      widgets: [
        { id: 'andamento-fatturato', name: 'Andamento fatturato' },
        { id: 'cashflow-annuale', name: 'Cashflow Annuale' },
        { id: 'conto-economico-annuale', name: 'Conto Economico Annuale' },
        { id: 'stato-patrimoniale-annuale', name: 'Stato Patrimoniale Annuale' },
        { id: 'kpi', name: 'KPI - Key Performance Index' },
        { id: 'roi', name: 'ROI - Return on Investment' },
        { id: 'roe', name: 'ROE - Return on Equity' },
        { id: 'ros', name: 'ROS - Return on Sales' },
        { id: 'indice-indipendenza-terzi', name: 'Indice di indipendenza da terzi' },
        { id: 'turnover-attivita', name: 'Turnover attività' },
        { id: 'zed-score', name: 'Zed Score' },
        { id: 'conto-economico', name: 'Conto Economico' },
        { id: 'analisi-redditivita', name: 'Analisi della redditività' },
        { id: 'analisi-reddituale-previsionale', name: 'Analisi reddituale previsionale' },
        { id: 'cash-flow-line', name: 'Cash Flow' },
        { id: 'cassa-disavanzo', name: 'Cassa e Disavanzo' },
        { id: 'andamento-vendite', name: 'Andamento delle vendite' },
        { id: 'valutazione-azienda', name: 'Valutazione Azienda - Venture Capital Method' },
        { id: 'fabbisogno-finanziamento', name: 'Fabbisogno di Finanziamento' },
        { id: 'analisi-reddituale-consuntiva', name: 'Analisi reddituale consuntiva' },
        { id: 'analisi-indicatori', name: 'Analisi degli indicatori' },
      ],
      publicEnabledWidgets: [],
      privateEnabledWidgets: [],
    };
  },
  methods: {
    saveDashboardConfig () {
      this.$api.setDashboardConfig(this.company.id, {
        publicEnabledWidgets: this.publicEnabledWidgets,
        privateEnabledWidgets: this.privateEnabledWidgets,
      })
        .then(() => {
          this.$emit('reload');
        })
      ;
    },
  },
  mounted () {
    this.$api.getDashboardConfig(this.company.id)
      .then(res => {
        this.publicEnabledWidgets = res.data?.publicEnabledWidgets || [];
        this.privateEnabledWidgets = res.data?.privateEnabledWidgets || [];
      })
      .catch(this.$log.errors)
    ;
  },
};

</script>
